export default "__VITE_ASSET__GmGIDuJs__"